<template>
  <v-row>
    <v-col cols="12" md="6">
      <div v-for="(invoiceGroup, ixivcgr) in invoiceGroups" :key="ixivcgr">
        <v-card elevation="4" class="my-2">
          <v-card-title primary-title> {{ invoiceGroup.name }} </v-card-title>
          <v-card-text>
            <v-data-table
                          :headers="headers"
                          :items="invoiceGroup.invoices"
                          :items-per-page="999"
                          return-object>
              <template v-slot:bottom>
                <span></span>
              </template>
              <template v-slot:item.due_date="{ value }">
                <span>{{
                  $moment.parseZone(value).format("DD/MM/YYYY")
                }}</span>
              </template>
              <template v-slot:item.amount="{ item }">
                <span
                      :class="{
                        'text-red':
                          $moment.parseZone(item.due_date) <
                          $moment.parseZone(item.payment_date),
                      }">{{ $filters.currency(amountDue(item), 'BRL') }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>

      <v-row class="mt-2">
        <v-col cols="6">
          <p class="text-h5">TOTAL A PAGAR</p>
        </v-col>
        <v-col cols="6">
          <p class="text-right text-h5">
            {{ $filters.currency(totalInvoices, 'BRL') }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6">
      <v-form :submit="submitUpdate">
        <v-row>
          <v-col cols="12" sm="6">
            <AutocompleteSelectInvoiceStatus
                                             :user="user"
                                             label="Situação"
                                             :statuses="[$INVOICE_STATUSES[1], $INVOICE_STATUSES[4]]"
                                             v-model="value.status"
                                             density="compact" />
          </v-col>
          <v-col
                 cols="12"
                 sm="6"
                 v-if="value.status == $INVOICE_STATUS_DIC.PAID.value">
            <AutocompleteSelectPaymentMethod
                                             :user="user"
                                             label="Forma de pagamento"
                                             v-model="value.payment_method"
                                             :rules="rules.required"
                                             :returnObject="true"
                                             :restrictedTypes="restrictedTypes"
                                             :allowOnline="allowOnlinePayments"
                                             :dueAmount="totalInvoices"
                                             density="compact" />
          </v-col>
          <v-col
                 cols="12"
                 md="5"
                 v-if="value.status == $INVOICE_STATUS_DIC.PAID.value">
            <v-text-field
                          label="Data do pagamento"
                          v-model="value.payment_date"
                          type="datetime-local"
                          :rules="rules.required"
                          :disabled="!!value?.payment_method?.allow_online_payment"
                          hide-details
                          density="compact">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="7">
            <AutocompleteSelectCashier v-if="!value?.payment_method?.allow_online_payment"
                                       :user="user"
                                       label="Caixa"
                                       v-model="value.cashier"
                                       :returnObject="true"
                                       :rules="rules.required"
                                       density="compact">
            </AutocompleteSelectCashier>
          </v-col>
          <v-col cols="12">
            <v-text-field
                          label="Código Referência"
                          v-model="value.ref"
                          hide-details></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
                        label="Histórico"
                        v-model="value.description"
                        hide-details></v-textarea>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn color="success" type="submit" v-if="!value?.payment_method?.allow_online_payment">
              <v-icon class="mr-2">mdi-content-save</v-icon>
              Baixar lançamentos
            </v-btn>
            <v-btn color="success" @click="initiateCheckout" v-if="value?.payment_method?.allow_online_payment">
              <v-icon class="mr-2">mdi-content-save</v-icon>
              Pagamento
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import AutocompleteSelectCashier from "./AutocompleteSelectCashier.vue";
import AutocompleteSelectInvoiceStatus from "./AutocompleteSelectInvoiceStatus.vue";
import AutocompleteSelectPaymentMethod from "./AutocompleteSelectPaymentMethod.vue";
import DialogCheckout from "./DialogCheckout.vue";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectInvoiceStatus,
    AutocompleteSelectPaymentMethod,
    AutocompleteSelectCashier,
    DialogCheckout,
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue", "complete", "created"],
  data() {
    return {
      requestingApi: null,
      brazilianBanks: [],
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Ref", align: "start", key: "ref", sortable: true },
        { title: "Descrição", align: "start", key: "description", sortable: true },
        { title: "Vencimento", align: "end", key: "due_date", sortable: true },
        { title: "Valor", align: "end", key: "amount", sortable: true },
      ],
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
      allowOnlinePayments: true
    };
  },
  created() {
    const vm = this;

    vm.allowOnlinePayments = !vm.modelValue?.invoices?.some(o => o.type === vm.$INVOICE_TYPE_DIC.BILL.value);
    if (!vm.modelValue?.status) {
      vm.value.status = vm.$INVOICE_STATUS_DIC.PAID.value;
    }
  },
  mounted() { },
  methods: {
    submitUpdate() {
      var vm = this;
      vm.value = {
        ...vm.value,
        invoices_ids: vm.invoiceIds,
        validation: {
          total: vm.totalInvoices,
        },
      };

      let _writeOffModel = vm.value
      _writeOffModel.invoices_ids = vm.invoiceIds
      _writeOffModel.validation = {
        total: vm.totalInvoices
      };
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.invoice
          .writeOff(_writeOffModel)
          .then((result) => {
            vm.$emit("created", result);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    initiateCheckout() {
      var vm = this;

      vm.requestingApi = true;
      api.checkout
        .initiate({ invoiceIds: vm.invoiceIds, due_amount: vm.amountDue })
        .then((result) => {
          let _oldCheckout = result?.oldCheckout || null;
          let _checkoutData = result?.data || null;

          // Check dueAmount and send informations
          // btoa(JSON.stringify(_checkoutData)
          if (_oldCheckout) {
            vm.$notify({
              type: "warn",
              text: 'Existe um pagamento em aberto. Finalize ou cancele o pagamento antes de criar um novo.',
            });
            vm.$router.push({ name: 'Checkout', query: { checkout: _oldCheckout.id, payment_method_id: vm.value?.payment_method?.id } })
          } else {
            vm.$router.push({ name: 'Checkout', query: { checkout: _checkoutData.id, payment_method_id: vm.value?.payment_method?.id } })
          }
          vm.$emit("complete");
        })
        .catch((err) => {
          if (err.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
          }
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    restrictedTypes() {
      const vm = this;
      const isSingleServiceInvoice = vm.value?.invoice?.type === vm.$INVOICE_TYPE_DIC.SERVICE.value;
      const isMultipleServiceInvoices = vm.value?.invoices?.length > 0 && vm.value?.invoices?.some(i => i.type === vm.$INVOICE_TYPE_DIC.SERVICE.value);
      let restricted = isSingleServiceInvoice || isMultipleServiceInvoices ? [vm.$PAYMENT_METHOD_TYPES_DIC.PIX.value] : [];

      if (vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value) {
        restricted.push(vm.$PAYMENT_METHOD_TYPES_DIC.BANK_TRANSFER.value);
      }
      return restricted;
    },
    invoiceGroups() {
      var vm = this;
      let _result = [];
      if (vm.value?.invoice?.id) {
        _result.push({
          name: vm.value?.invoice?.to?.name,
          invoices: [vm.value?.invoice],
        });
        return _result;
      } else {
        let _invoices = vm.value?.invoices || [];
        let _invoiceDic = {};
        _invoices.forEach((invoice) => {
          if (!_invoiceDic[invoice?.to?.id]) {
            _invoiceDic[invoice?.to?.id] = {
              name: invoice?.to?.name,
              invoices: [],
            };
          }
          _invoiceDic[invoice?.to?.id].invoices.push(invoice);
        });
        return Object.values(_invoiceDic);
      }
    },
    amountDue() {
      var vm = this;

      return function (invoice) {
        let _dueDate = vm.$moment.parseZone(invoice.due_date);
        if (_dueDate < vm.$moment.parseZone(vm.value?.payment_date)) {
          return invoice.amount;
        } else {
          return invoice.amount - (invoice.early_payment_discount || 0);
        }
      };
    },
    totalInvoices() {
      var vm = this;
      let _paymentDate = vm.$moment.parseZone(vm.value.payment_date);
      if (vm.value?.invoice?.id) {
        let _invoice = vm.value?.invoice;
        let _dueDate = vm.$moment.parseZone(_invoice.due_date);
        let _discount = _invoice.early_payment_discount || 0;

        return _paymentDate <= _dueDate
          ? _invoice.amount - _discount
          : _invoice.amount;
      } else if ((vm.value?.invoices || []).length > 0) {
        return vm.value?.invoices?.reduce((acc, curr) => {
          let _dueDate = vm.$moment.parseZone(curr.due_date);
          let _discount = curr.early_payment_discount || 0;

          return (
            acc +
            (_paymentDate <= _dueDate ? curr.amount - _discount : curr.amount)
          );
        }, 0);
      } else {
        // no invoices found, return 0 as default value
        return 0;
      }
    },
    invoiceIds() {
      var vm = this;
      let _invoiceIds = [];
      if (vm.value?.invoice?.id) {
        _invoiceIds.push(vm.value?.invoice?.id);
      } else if (vm.value?.invoices) {
        _invoiceIds = vm.value?.invoices.map((i) => i.id);
      }
      return _invoiceIds;
    },
  },
  watch: {
    // group(newVal) {
    //   console.debug("GROUP changed", newVal);
    //   this.editGroup = newVal || this.generateEmpty();
    // },
  },
};
</script>